import axios, { Axios } from "axios";
import { authenticationService } from "../AuthinticationService";
import Config from "../../config/Config";
import AlertConfirm from "../../components/modals/Confirm";
import { globalToast } from "../../components/popups/ToastProvider";

const globalUrl = Config.globalUrl;

class RestApi {
  async get(url) {
    try {
      let authConfig = await this.getAuthConfig(false);
      return await axios.get(`${globalUrl}/api/v1/webapp/${url}`, authConfig);
    } catch (err) {
      // Check for authentication/authorization errors
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        console.log("Authentication failed - logging out user");
        authenticationService.logout();
        // Emit custom event instead of hard redirect
        window.dispatchEvent(new CustomEvent('forceLogout', { detail: 'Authentication failed' }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: err.response.status, error: 'Authentication failed' };
      }

      // Check for site change (409 SITE_CHANGED)
      if (err.response && err.response.status === 409 && 
          err.response.data && err.response.data.error === 'SITE_CHANGED') {
        const siteInfo = err.response.data.siteChangeInfo;
        console.log(`Site changed from ${siteInfo.previousSite} to ${siteInfo.newSite} - logging out user`);
        authenticationService.logout();
        // Emit custom event with site change details
        window.dispatchEvent(new CustomEvent('forceLogout', { 
          detail: `Your site assignment changed from "${siteInfo.previousSite}" to "${siteInfo.newSiteName}". Please log in again.`
        }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: 409, error: 'Site changed' };
      }

      // Check for locked user (422 with specific message)
      if (err.response && err.response.status === 422 && 
          err.response.data && err.response.data.message && 
          err.response.data.message.includes("locked")) {
        console.log("User is locked - logging out user");
        authenticationService.logout();
        // Emit custom event instead of hard redirect
        window.dispatchEvent(new CustomEvent('forceLogout', { detail: 'User is locked' }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: 422, error: 'User is locked' };
      }

      let errText = "";
      if (err.response && err.response.data && err.response.data.message) {
        errText = err.response.data.message;
      }
      if (err.name !== "AxiosError") {
        // console.log("shuld see toast");
        // setTimeout(() => {
        //   globalToast.add({
        //     type: "error",
        //     title: "An Error Has Occurred",
        //     message: errText || "Something went wrong",
        //   });
        // }, 0);
      }
      throw err;
    }
  }

  async post(url, data) {
    try {
      let authConfig = await this.getAuthConfig(false);
      return await axios.post(
        `${globalUrl}/api/v1/webapp/${url}`,
        data,
        authConfig
      );
    } catch (err) {
      // Check for authentication/authorization errors
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        console.log("Authentication failed - logging out user");
        authenticationService.logout();
        // Emit custom event instead of hard redirect
        window.dispatchEvent(new CustomEvent('forceLogout', { detail: 'Authentication failed' }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: err.response.status, error: 'Authentication failed' };
      }

      // Check for site change (409 SITE_CHANGED)
      if (err.response && err.response.status === 409 && 
          err.response.data && err.response.data.error === 'SITE_CHANGED') {
        const siteInfo = err.response.data.siteChangeInfo;
        console.log(`Site changed from ${siteInfo.previousSite} to ${siteInfo.newSite} - logging out user`);
        authenticationService.logout();
        // Emit custom event with site change details
        window.dispatchEvent(new CustomEvent('forceLogout', { 
          detail: `Your site assignment changed from "${siteInfo.previousSite}" to "${siteInfo.newSiteName}". Please log in again.`
        }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: 409, error: 'Site changed' };
      }

      // Check for locked user (422 with specific message)
      if (err.response && err.response.status === 422 && 
          err.response.data && err.response.data.message && 
          err.response.data.message.includes("locked")) {
        console.log("User is locked - logging out user");
        authenticationService.logout();
        // Emit custom event instead of hard redirect
        window.dispatchEvent(new CustomEvent('forceLogout', { detail: 'User is locked' }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: 422, error: 'User is locked' };
      }

      let errText = "";
      if (err.response && err.response.data && err.response.data.message) {
        errText = err.response.data.message;
      }

      if (err.name !== "AxiosError") {
        // return await AlertConfirm(
        //   {
        //     proceedLabel: "Ok",
        //     cancelLabel: "none",
        //     options: { hasSVG: true, svgName: "alert-triangle" },
        //   },
        //   errText,
        //   `An Error Has Occured`
        // );
      }
      throw err;
    }
  }

  async postFiles(url, data) {
    try {
      ;
      let authConfig = await this.getAuthConfig(true);
      const myAxios = axios.create(authConfig);
      return await myAxios.post(`${globalUrl}/api/v1/webapp/${url}`, data);
    } catch (err) {
      // Check for authentication/authorization errors
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        console.log("Authentication failed - logging out user");
        authenticationService.logout();
        // Emit custom event instead of hard redirect
        window.dispatchEvent(new CustomEvent('forceLogout', { detail: 'Authentication failed' }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: err.response.status, error: 'Authentication failed' };
      }

      // Check for site change (409 SITE_CHANGED)
      if (err.response && err.response.status === 409 && 
          err.response.data && err.response.data.error === 'SITE_CHANGED') {
        const siteInfo = err.response.data.siteChangeInfo;
        console.log(`Site changed from ${siteInfo.previousSite} to ${siteInfo.newSite} - logging out user`);
        authenticationService.logout();
        // Emit custom event with site change details
        window.dispatchEvent(new CustomEvent('forceLogout', { 
          detail: `Your site assignment changed from "${siteInfo.previousSite}" to "${siteInfo.newSiteName}". Please log in again.`
        }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: 409, error: 'Site changed' };
      }

      // Check for locked user (422 with specific message)
      if (err.response && err.response.status === 422 && 
          err.response.data && err.response.data.message && 
          err.response.data.message.includes("locked")) {
        console.log("User is locked - logging out user");
        authenticationService.logout();
        // Emit custom event instead of hard redirect
        window.dispatchEvent(new CustomEvent('forceLogout', { detail: 'User is locked' }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: 422, error: 'User is locked' };
      }
      
      console.log("err", err);
      return err;
    }
  }

  async delete(url) {
    try {
      let authConfig = await this.getAuthConfig(false);
      return await axios.delete(
        `${globalUrl}/api/v1/webapp/${url}`,
        authConfig
      );
    } catch (err) {
      // Check for authentication/authorization errors
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        console.log("Authentication failed - logging out user");
        authenticationService.logout();
        // Emit custom event instead of hard redirect
        window.dispatchEvent(new CustomEvent('forceLogout', { detail: 'Authentication failed' }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: err.response.status, error: 'Authentication failed' };
      }

      // Check for site change (409 SITE_CHANGED)
      if (err.response && err.response.status === 409 && 
          err.response.data && err.response.data.error === 'SITE_CHANGED') {
        const siteInfo = err.response.data.siteChangeInfo;
        console.log(`Site changed from ${siteInfo.previousSite} to ${siteInfo.newSite} - logging out user`);
        authenticationService.logout();
        // Emit custom event with site change details
        window.dispatchEvent(new CustomEvent('forceLogout', { 
          detail: `Your site assignment changed from "${siteInfo.previousSite}" to "${siteInfo.newSiteName}". Please log in again.`
        }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: 409, error: 'Site changed' };
      }

      // Check for locked user (422 with specific message)
      if (err.response && err.response.status === 422 && 
          err.response.data && err.response.data.message && 
          err.response.data.message.includes("locked")) {
        console.log("User is locked - logging out user");
        authenticationService.logout();
        // Emit custom event instead of hard redirect
        window.dispatchEvent(new CustomEvent('forceLogout', { detail: 'User is locked' }));
        // Return a consistent response structure to prevent undefined errors
        return { data: null, status: 422, error: 'User is locked' };
      }
      
      console.log("err", err);
      return err;
    }
  }

  async getAuthConfig(isFiles) {
    const currentUser = authenticationService.currentUserValue;

    const config =
      currentUser && isFiles
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: currentUser.token,
            },
          }
        : currentUser
        ? {
            headers: {
              "Content-Type": "application/json",
              Authorization: currentUser.token,
            },
          }
        : { headers: { "Content-Type": "application/json" } };

    return await new Promise(async (resolve) => {
      let headers = config.headers || {};
      await authenticationService
        .currentSessionToken()
        .then(async (accessToken) => {
          let user = JSON.parse(
            JSON.stringify(authenticationService.currentUserValue)
          );
          if (accessToken !== user["token"]) {
            user["token"] = accessToken;
            // await authenticationService.setUserData(user)
          }
          headers["Authorization"] = accessToken;
          config.headers = headers;
          resolve(config);
        })
        .catch(() => {
          config.headers = headers;
          resolve(config);
        });
    });
  }
}

let restApi = new RestApi();
export default restApi;
